import React from 'react';
import bn from "../../../utils/bemnames";
import {getPrevEventStatusIndicatorClassName, getPrevEventStatusLetter} from '../../../utils/event';

const bem = bn.create('football-competitor-last-results-bar');

interface IProps {
  meetingResults: string[]
  isMobile?: boolean
}

const CompetitorLastResultsBar: React.FC<IProps> = ({meetingResults, isMobile = false}) => {
  return (
    <div className={`${bem.b()} ${isMobile ? bem.b() +'--mobile' : ''} `}>
      {meetingResults.length > 0 && meetingResults.map((meetingResult, index) => {
        return (
          <div
            className={`${bem.e('stats-item')} ${bem.e(getPrevEventStatusIndicatorClassName(meetingResult))}`}
            key={index}
          >{getPrevEventStatusLetter(meetingResult)}</div>
        )
      })}
    </div>
  )
}

export default CompetitorLastResultsBar;
